import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source"]
  toClipboard(){
    navigator.clipboard.writeText(this.sourceTarget.querySelector('p').textContent);
  }
}
